import {SyncStatusItem} from '../../interfaces/core/sync-status-item';
import {SyncException} from '../../exceptions/sync.exception';
import {TableName} from '../../enums/core/table-name';
import {Injectable} from '@angular/core';
import {ConflictHandlerInstance} from '../../interfaces/core/conflict-handler-instance';
import {CdRaiConflictHandler} from './cd-rai-conflict-handler';
import {TtActivityEntryConflictHandler} from './tt-activity-entry-conflict-handler';

@Injectable({
  providedIn: 'root'
})
export class ConflictHandler {

  /**
   *
   * @param cdRaiConflictHandler
   * @param ttActivityEntryConflictHandler
   */
  constructor(private cdRaiConflictHandler: CdRaiConflictHandler,
              private ttActivityEntryConflictHandler: TtActivityEntryConflictHandler) {
  }

  /**
   *
   * @param syncStatusItem
   * @param syncException
   */
  public async handleConflict(syncStatusItem: SyncStatusItem, syncException: SyncException): Promise<void> {
    if(syncException.code !== 409) {
      return;
    }

    let conflictHandlerInstance: ConflictHandlerInstance = null;

    switch(syncStatusItem.tableName) {
      case TableName.CdRais:
        conflictHandlerInstance = this.cdRaiConflictHandler;
        break;

      case TableName.CdMdsAnswers:
        conflictHandlerInstance = this.cdRaiConflictHandler;
        break;

      case TableName.TtActivityEntries:
        conflictHandlerInstance = this.ttActivityEntryConflictHandler;
        break;
    }

    if(conflictHandlerInstance) {
      await conflictHandlerInstance.handleConflict(syncStatusItem, syncException);
    }
  }

}
